// Accordéons pour Product Details Tabs
document.addEventListener('DOMContentLoaded', function() {
  const productTabsSection = document.querySelector('.m-product-details-tabs');
  
  if (!productTabsSection) return;
  
  const tabContents = productTabsSection.querySelectorAll('.m-tab-content');
  const tabHeaders = productTabsSection.querySelectorAll('.m-tab-header');
  
  // Identifier et cacher les accordéons vides
  const visibleTabs = [];
  
  tabContents.forEach((tab, index) => {
    const inner = tab.querySelector('.m-tab-content__inner');
    
    // Vérifier si le contenu est VRAIMENT vide (pas d'enfants HTML)
    const isEmpty = !inner || inner.children.length === 0;
    
    if (isEmpty) {
      // SUPPRIMER complètement du DOM
      tab.remove();
      if (tabHeaders[index]) {
        tabHeaders[index].remove();
      }
    } else {
      visibleTabs.push({ tab, index });
      
      // Récupérer le titre depuis le header
      let title = 'Section';
      if (tabHeaders[index]) {
        title = tabHeaders[index].textContent.trim();
      }
      
      tab.setAttribute('data-tab-title', title);
    }
  });
  
  // Ouvrir le premier accordéon visible par défaut
  if (visibleTabs.length > 0) {
    visibleTabs[0].tab.classList.add('active');
  }
  
  // Gérer les clics
  visibleTabs.forEach(({ tab }) => {
    tab.addEventListener('click', function(e) {
      const rect = this.getBoundingClientRect();
      const clickY = e.clientY - rect.top;
      
      if (clickY < 60) {
        this.classList.toggle('active');
      }
    });
  });
});